import { call, put } from 'redux-saga/effects'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	uploadUserAvatarFailure,
	uploadUserAvatarSuccess,
	getUserSuccess,
} from 'redux/user/reducer'
import { PayloadAction } from '@reduxjs/toolkit'
import { IUser } from './types'

export function* uploadUserAvatarSaga({ payload }: PayloadAction<{ file: File, isTeam: boolean }>) {
	try {
		const formData = new FormData()
		formData.append('avatar', payload.file)

		const {
			data,
			message,
		}: {
			data: { user: IUser }
			message: string
		} = yield call(apiMiddleware, {
			url: payload.isTeam
				? app_config.services.uploadTeamLogo
				: app_config.services.uploadUserAvatar,
			method: 'POST',
			data: formData,
			transform: false,
			contentType: payload.file.type,
		})

		yield put(getUserSuccess(data.user))
		yield put(uploadUserAvatarSuccess())

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(uploadUserAvatarFailure())
	}
}
